import { WappMode } from '@weblite-wapps/protocol'
import {
  VitrineWappPanel,
  CallWappPanel,
  RahkarWappPanel,
  KoolehWappPanel,
  JaryanWappPanel,
  MavakebWappPanel,
  CourseVitrineWappPanel,
} from '$logic/wapp-panels/static-wapp-panels'

export type StaticPanelType =
  | 'kooleh'
  | 'jaryan'
  | 'vitrine'
  | 'courseVitrine'
  | 'call'
  | 'rahkar'
  | 'mavakeb'

export enum StaticPanelWappId {
  KOOLEH = 'jaryan-kooleh',
  JARYAN = 'jaryan-jaryan',
  MAVAKEB = 'rahkar-rahkar-main',
  VITRINE = 'channel-vitrine-channel-vitrine',
  COURSE_VITRINE = 'vitrine-course-vitrine',
  MOOKEB_VITRINE = 'jaryan-vitrine-mookeb',
  CALL = 'call-call',
  GROUP_CALL = 'call-meet',
  LIVE = 'call-live',
  TRIBUNE = 'call-tribune',
  CLASSROOM = 'call-classroom',
  RAHKAR = 'rahkar-rahkar-main',
}

export const wappIdToStaticPanel = {
  [StaticPanelWappId.KOOLEH]: KoolehWappPanel,
  [StaticPanelWappId.JARYAN]: JaryanWappPanel,
  [StaticPanelWappId.VITRINE]: VitrineWappPanel,
  [StaticPanelWappId.COURSE_VITRINE]: CourseVitrineWappPanel,
  [StaticPanelWappId.MOOKEB_VITRINE]: VitrineWappPanel,
  [StaticPanelWappId.CALL]: CallWappPanel,
  [StaticPanelWappId.GROUP_CALL]: CallWappPanel,
  [StaticPanelWappId.LIVE]: CallWappPanel,
  [StaticPanelWappId.TRIBUNE]: CallWappPanel,
  [StaticPanelWappId.CLASSROOM]: CallWappPanel,
  [StaticPanelWappId.RAHKAR]: RahkarWappPanel,
  [StaticPanelWappId.MAVAKEB]: MavakebWappPanel,
}

export const staticPanelNameToStaticPanel = {
  kooleh: KoolehWappPanel,
  jaryan: JaryanWappPanel,
  vitrine: VitrineWappPanel,
  courseVitrine: CourseVitrineWappPanel,
  call: CallWappPanel,
  rahkar: RahkarWappPanel,
  mavakeb: MavakebWappPanel,
}

export const wappIdToStaticPanelName: Record<
  StaticPanelWappId,
  StaticPanelType
> = {
  [StaticPanelWappId.KOOLEH]: 'kooleh',
  [StaticPanelWappId.JARYAN]: 'jaryan',
  [StaticPanelWappId.VITRINE]: 'vitrine',
  [StaticPanelWappId.COURSE_VITRINE]: 'courseVitrine',
  [StaticPanelWappId.MOOKEB_VITRINE]: 'vitrine',
  [StaticPanelWappId.CALL]: 'call',
  [StaticPanelWappId.GROUP_CALL]: 'call',
  [StaticPanelWappId.LIVE]: 'call',
  [StaticPanelWappId.CLASSROOM]: 'call',
  [StaticPanelWappId.TRIBUNE]: 'call',
  [StaticPanelWappId.RAHKAR]: 'rahkar',
  [StaticPanelWappId.MAVAKEB]: 'mavakeb',
}
export const getStaticPanelByName = (name: StaticPanelType) =>
  staticPanelNameToStaticPanel[name] || null

export const getStaticPanelByWappId = (wappId: StaticPanelWappId) =>
  wappIdToStaticPanel[wappId] || null

export const getStaticPanelByWappSessionId = (sessionId: string) => {
  const panels = Object.values(staticPanelNameToStaticPanel)
  for (const panel of panels)
    if (panel.getWappMeta()?.wappSessionId === sessionId) return panel

  return null
}

export const isValidStaticWapp = ({
  wappId,
  mode,
}: {
  wappId: string
  mode: WappMode
}) =>
  mode === WappMode.STATIC &&
  Boolean(wappIdToStaticPanel[wappId as StaticPanelWappId])
